exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-dropdown[data-v-14c5e1d7]{position:relative}.payment-dropdown[data-v-14c5e1d7] .dropdown-menu{position:absolute;bottom:100%!important;top:auto!important;margin-bottom:.125rem;will-change:transform}.payment-dropdown[data-v-14c5e1d7] .dropdown-menu,.payment-dropdown[data-v-14c5e1d7] .dropdown-menu.show{-webkit-transform:none!important;transform:none!important}.payment-dropdown[data-v-14c5e1d7] .dropdown-toggle:after{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14c5e1d7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/POS/Total.vue
// module id = ivUO
// module chunks = 0